import { render, staticRenderFns } from "./delDevice.vue?vue&type=template&id=10bc9180&scoped=true"
import script from "./delDevice.vue?vue&type=script&lang=js"
export * from "./delDevice.vue?vue&type=script&lang=js"
import style0 from "./delDevice.vue?vue&type=style&index=0&id=10bc9180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc9180",
  null
  
)

export default component.exports